// extracted by mini-css-extract-plugin
module.exports = {"timeRange":"CouponScheduleSummary_timeRange__3oaQ7"};